import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'
import AdvancedFiltersModal from './AdvancedFiltersModal/index.vue'
import BoardResult from './BoardResult/index.vue'
import tableHelper from '@/helpers/table'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faFilePdf,
	faCircleInfo,
	faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons'

import api from '@/helpers/fetch'

library.add(faTrashAlt, faFilePdf, faCircleInfo, faMagnifyingGlass)

@Component({
	components: {
		Loader,
		vSelect,
		AdvancedFiltersModal,
		BoardResult,
	},
})
export default class Thermometer extends Vue {
	options = {
		calc_subject: [] as Array<any>,
		company_name: [] as Array<any>,
		company_group_name: [] as Array<any>,
	}

	boardHeaderLine: any[] = [
		{ label: '#', columnShort: true },
		{ label: 'Tese', fullWidth: true },
		{ label: 'Empresa 1 (exemplo)' },
		{ label: 'Empresa 2 (exemplo)' },
	]

	example = true
	boardBody = [
		[
			{ label: '1' },
			{ label: 'Tese 1 (exemplo)' },
			{ label: 'true', value: true },
			{ label: 'false', value: false },
		],
		[
			{ label: '2' },
			{ label: 'Tese 2 (exemplo)' },
			{ label: 'false', value: false },
			{ label: 'true', value: true },
		],
	] as Array<any>

	queryCompanyLoading = false

	query = {
		company: [] as any[],
	}

	async mounted() {
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
		await this.loadOptions()
	}

	loadingOptions = true
	async loadOptions() {
		const res = await api.get(
			'/api/thermometer/collections/options?options=company_name,company_group_name,calc_subject&short=true',
		)

		res.data.options.company_name.map((option) => {
			option.type = 'company'
			option.label = option.name
			return option
		})

		res.data.options.company_group_name.map((option) => {
			option.label = option.name + ' (grupo*)'
			option.type = 'group'
			return option
		})

		this.options = res.data.options

		this.loadingOptions = false
	}

	get groupAndCompaniesList() {
		const list = [
			...this.options.company_name,
			...this.options.company_group_name,
		]

		list.sort((a, b) => a.name.localeCompare(b.name))
		return list
	}

	sendToBoard(subjectsByCompany, type = 'company') {
		subjectsByCompany.forEach((item) => {
			this.sendEntryToBoard(item, type)
		})

		this.makeMatrix()
	}

	sendSingleToBoard(currentEntry, type = 'company') {
		this.sendEntryToBoard(currentEntry, type)

		this.makeMatrix()
	}

	boardCompaniesSet = new Set()
	boardSubjectsMap = new Map()
	maxNumOfCompanies = 5
	sendEntryToBoard(currentEntry, type = 'company') {
		const companyName =
			type === 'company'
				? currentEntry.company_name.trim()
				: currentEntry.company_group_name.trim()
		this.boardCompaniesSet.add(companyName)

		const subjectName = currentEntry.calc_subject.name
		let companyData = this.boardSubjectsMap.get(subjectName)
		if (!companyData) {
			companyData = {}
		}

		companyData[companyName] = companyData[companyName] || {
			value: true,
		}

		const cnj = currentEntry.cnj
		if (cnj) {
			companyData[companyName].cnj = cnj
		}

		this.boardSubjectsMap.set(subjectName, companyData)
	}

	key = 0
	makeMatrix() {
		this.example = false

		const companiesOnBoard: any = Array.from(this.boardCompaniesSet)
		this.boardHeaderLine = [
			{ label: '#', columnShort: true },
			{ label: 'Tese', fullWidth: true },
			...companiesOnBoard.map((name) => {
				return { label: name, deletable: true }
			}),
		]

		this.boardBody = []

		this.boardSubjectsMap.forEach((subjectData, key) => {
			const newLine: any[] = [
				{ label: this.boardBody.length + 1 },
				{ label: key, fullWidth: true, deletable: true },
			]

			companiesOnBoard.forEach((company) => {
				const companyData = subjectData[company.trim()]
				const val = companyData?.value || false

				newLine.push({
					label: val.toString(),
					value: val,
					cnj: companyData?.cnj,
				})
			})

			this.boardBody.push(newLine)
		})

		this.key++
	}

	formatCNJ(val) {
		return tableHelper.formatCNJ(val)
	}

	async queryEntriesByCompany(name, type) {
		if (!name) return

		let query = ''
		this.loadingOptions = true
		if (type === 'company') {
			query = `company_name=${encodeURIComponent(name)}`
		} else {
			query = `company_group_name=${encodeURIComponent(name)}`
		}
		const res = await api.get(
			`/api/thermometer/collections/search?short=true&items=all&page=all&${query}`,
		)

		res.data.thermometer = res.data.thermometer.filter(
			(item) =>
				item.company_name === name || item.company_group_name === name,
		)

		if (res.ok) {
			this.sendToBoard(res.data.thermometer, type)
		} else {
			console.info('erro consulta')
		}

		this.loadingOptions = false
	}

	downloading = false
	async downloadPDF() {
		this.getUser()
		this.downloading = true
		const resp = await api.post('/api/termometro/pdf', {
			matrix: [this.boardHeaderLine, ...this.boardBody],
			user: this.user,
		})
		this.downloading = false

		const bufferArray = resp.pdfData.body
		const bytes = new Uint8Array(bufferArray.data)
		const reportName = resp.pdfData.fileName

		const blob = new Blob([bytes], { type: 'application/pdf' })
		const link = document.createElement('a')

		link.href = window.URL.createObjectURL(blob)
		const fileName = reportName + '-' + new Date().toISOString() + '.pdf'
		link.download = fileName
		link.click()
	}

	user: any = null
	getUser() {
		if (!this.user) {
			this.user = JSON.parse(localStorage.getItem('user') || '')
		}
	}

	onCompanyChange(option) {
		const name = option?.name
		if (!name) {
			this.query.company = []
			return
		}
		this.queryEntriesByCompany(name, option.type)

		const Window: any = window
		if (Window.gtag) {
			this.getUser()
			Window.gtag('event', 'termometro_empresa_incluida', {
				identificador_usuario: 'id-' + this.user?.id,
				empresa: name,
			})
		}
	}

	onSubjectChange(name) {
		this.boardSubjectsMap.set(name, { companySet: new Set() })

		this.makeMatrix()
	}

	removeCompany(name) {
		this.boardCompaniesSet.delete(name.trim())
		this.makeMatrix()
	}

	removeSubject(name) {
		this.boardSubjectsMap.delete(name)
		this.makeMatrix()
	}

	toggleResult(companyName, subjectName, newValue) {
		if (!this.example) {
			const subjectData = this.boardSubjectsMap.get(subjectName)
			const trimmedCompanyName = companyName.trim()
			subjectData[trimmedCompanyName] =
				subjectData[trimmedCompanyName] || {}
			const companyData = subjectData[trimmedCompanyName]
			companyData.value = newValue

			this.makeMatrix()
		}
	}

	sendToBoardAdvancedFilters(list) {
		this.sendToBoard(list, 'company')
	}

	openAdvancedSearch() {
		this.$bvModal.show('termometro-filtros-avancados')

		const modal: any = this.$refs.AdvancedFiltersModal
		modal.start()
	}

	onSearch(allItems, search) {
		if (typeof search !== 'string') return
		const searchArray = search?.split(' ')

		const result = allItems.filter((item) => {
			if (item) {
				const name = removeAccents(item.name.toLowerCase())

				return searchArray.every((string) => {
					return name.includes(removeAccents(string.toLowerCase()))
				})
			}

			return false
		})

		return result
	}

	reset() {
		this.boardCompaniesSet.clear()
		this.boardSubjectsMap.clear()
		this.makeMatrix()
	}
}

function removeAccents(str) {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
